import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, IconComponent } from '@sc/ui-components';

export interface AppointmentsValidationInBasketData {
  title: string;
  text: string;
}
@Component({
  selector: 'sc-appointment-validation-in-basket-dialog',
  styleUrls: ['./appointment-validation-in-basket-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonComponent, TranslateModule],
  template: `
    <div class="container">
      <div class="close">
        <button type="button" class="close-btn" (click)="onCloseClick()">
          <sc-icon name="close"></sc-icon>
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate: { dialogTitle: title }
          }}</span>
        </button>
      </div>
      <h1
        mat-dialog-title
        class="sc-design-title-h1"
        id="appointment-validation-in-basket-title-id"
      >
        {{ title }}
      </h1>
      <div class="validation-text">{{ text }}</div>
      <sc-button
        id="validateBtn"
        buttonType="primary"
        (click)="onValidateClick()"
        >{{
          'PlanningBasketAppointment.dialog.validateBtn' | translate
        }}</sc-button
      >
    </div>
  `,
})
export class AppointmentsValidationInBasketDialogComponent implements OnInit {
  title: string;
  text: string;

  constructor(
    private readonly dialogRef: MatDialogRef<AppointmentsValidationInBasketDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: AppointmentsValidationInBasketData
  ) {}

  ngOnInit(): void {
    this.title = this.dialogData.title;
    this.text = this.dialogData.text;
  }

  onCloseClick() {
    this.dialogRef.close('cancel');
  }

  onValidateClick() {
    this.dialogRef.close('validate');
  }
}
